<div class="flex items-start space-x-3 group">
  <!-- Toggle Switch -->
  <div class="relative">
    <!-- Hidden native checkbox for accessibility -->
    <input [id]="toggleId" type="checkbox" class="sr-only" [checked]="checked" [disabled]="disabled"
      (change)="handleChange($event)" (focus)="onFocus()" (blur)="onBlur()" />

    <!-- Custom toggle switch -->
    <label [for]="toggleId" [class]="computedToggleClasses()" [attr.aria-checked]="checked"
      [attr.aria-disabled]="disabled" role="switch" tabindex="0" (keydown)="handleKeyDown($event)">
      <!-- Toggle thumb -->
      <div [class]="computedThumbClasses()" [style.--thumb-x]="thumbTranslate()">
        <!-- Thumb icon (optional) -->
        @if (showIcons) {
        <!-- Use a full-area grid to center the icon deterministically -->
        <div class="absolute inset-0 z-10 grid place-items-center pointer-events-none">
          <div class="scale-75 leading-none">
            <ui-icon [name]="currentIcon()" [size]="thumbIconSize()" [customClass]="
                    checked
                      ? 'transition-all duration-300 text-white ui-drop-shadow-strong'
                      : 'transition-all duration-300 text-gray-600 dark:text-gray-700'
                  "></ui-icon>
          </div>
        </div>
        }

        <!-- Glass shimmer effect on thumb -->
        <div
          class="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none overflow-hidden rounded-full">
          <div class="absolute inset-0 bg-gradient-to-r from-transparent via-primary-400/30 to-transparent
                          transform -skew-x-12 -translate-x-full group-hover:translate-x-full
                          transition-transform duration-1000 ease-out"></div>
        </div>

        <!-- Premium floating particles on thumb -->
        @if (variant === 'premium') {
        <div
          class="absolute inset-0 overflow-hidden pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-700">
          <div class="absolute top-1/4 left-1/4 w-0.5 h-0.5 bg-primary-400/60 rounded-full animate-pulse"></div>
          <div class="absolute bottom-1/4 right-1/4 w-0.5 h-0.5 bg-white/60 rounded-full animate-pulse delay-500"></div>
        </div>
        }
      </div>

      <!-- Track glass shimmer effect -->
      <div
        class="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none overflow-hidden rounded-full">
        <div class="absolute inset-0 bg-gradient-to-r from-transparent via-primary-400/20 to-transparent
                        transform -skew-x-12 -translate-x-full group-hover:translate-x-full
                        transition-transform duration-1000 ease-out"></div>
      </div>

      <!-- Premium floating particles on track -->
      @if (variant === 'premium') {
      <div
        class="absolute inset-0 overflow-hidden pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-700">
        <div class="absolute top-1/3 left-1/6 w-0.5 h-0.5 bg-primary-400/40 rounded-full animate-pulse delay-200"></div>
        <div class="absolute bottom-1/3 right-1/6 w-0.5 h-0.5 bg-white/30 rounded-full animate-pulse delay-700"></div>
        <div class="absolute top-2/3 left-2/3 w-0.5 h-0.5 bg-primary-300/50 rounded-full animate-pulse delay-1200">
        </div>
      </div>
      }

      <!-- On state glow -->
      @if (checked) {
      <div class="absolute inset-0 rounded-full opacity-60 pointer-events-none">
        <div class="absolute inset-0 bg-primary-500/15 rounded-full animate-glass-pulse"></div>
      </div>
      }

      <!-- State indicator labels (optional) -->
      @if (showLabels) {
      <div class="absolute inset-0 flex items-center justify-between px-1 text-xs font-medium pointer-events-none">
        <span class="transition-opacity duration-300" [class.opacity-100]="!checked" [class.opacity-0]="checked"
          [class.text-gray-600]="true" [class.dark:text-gray-400]="true">
          {{ offLabel }}
        </span>
        <span class="transition-opacity duration-300" [class.opacity-100]="checked" [class.opacity-0]="!checked"
          [class.text-primary-700]="true" [class.dark:text-primary-300]="true">
          {{ onLabel }}
        </span>
      </div>
      }
    </label>
  </div>

  <!-- Label and description -->
  @if (label || description) {
  <div class="flex-1 min-w-0">
    @if (label) {
    <label [for]="toggleId" [class]="computedLabelClasses()">
      {{ label }}
      @if (required) {
      <span class="text-red-500 ml-1">*</span>
      }
    </label>
    } @if (description) {
    <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
      {{ description }}
    </p>
    }
  </div>
  }
</div>

<!-- Error message -->
@if (errorMessage) {
<p class="text-sm text-red-600 dark:text-red-400 mt-2 flex items-center">
  <ui-icon name="alert-circle" size="sm" customClass="mr-1 shrink-0"></ui-icon>
  {{ errorMessage }}
</p>
}

<!-- Success message -->
@if (successMessage) {
<p class="text-sm text-cyan-600 dark:text-cyan-400 mt-2 flex items-center">
  <ui-icon name="check" size="sm" customClass="mr-1 shrink-0"></ui-icon>
  {{ successMessage }}
</p>
}